import styled, { css } from 'styled-components';

import variables from '../../../styles/variables';

interface Props {
  $isSmall: boolean;
}

export const CardWrapper = styled.div<{$disableBorder?: boolean;}>`
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ $disableBorder }) => (!$disableBorder && css`
    border: solid 2px ${variables.colorGreyLight};
    `)}
  border-radius: 10px;
`;

const normalCss = css`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  height: 130px;
  #startButton {
    padding: 10px 15px;
  }
  @media screen and (max-width: 499px) {
    height: auto;
    padding: 15px;
    #startButton {
      letter-spacing: 0.64px;
      min-width: 110px;
    }
  }
`;

const smallCss = css`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  height: 100px;
  #startButton {
    padding: 13px 10px;
  }
  @media screen and (max-width: 499px) {
    height: auto;
    padding: 13px;
    #startButton {
      letter-spacing: 0.64px;
      min-width: 110px;
    }
  }
`;

export const ContentWrapper = styled.div`
  ${({ $isSmall }: Props) => ($isSmall ? smallCss : normalCss)}
`;
